// @flow
import {
    type Action as TypeaheadSuggestionActions,
    type TypeaheadSuggestionType
} from '../actions/typeaheadSuggestion';
import type {Action as SearchQueryAction} from '../actions/searchQuery';

export type State = $Shape<TypeaheadSuggestionType>;

const initialState = {};

export default function reducer(
    state: State = initialState,
    action: TypeaheadSuggestionActions | SearchQueryAction
): State {
    switch (action.type) {
        case 'TYPEAHEAD_SUGGESTION/INIT':
            return {...state, ...action.payload};
        case 'SEARCH_QUERY/COMPLETE':
            if (
                action.payload &&
                action.payload.results &&
                action.payload.results.typeaheadSuggestion
            ) {
                const {typeaheadSuggestion} = action.payload.results;
                return {
                    ...state,
                    term: typeaheadSuggestion.term || '',
                    uuid: typeaheadSuggestion.uuid
                };
            }
            return state;
        default:
            (action: empty); // eslint-disable-line no-unused-expressions
            return state;
    }
}
